import React from "react";

const Java_Fibonacci = () => {
  return (
    <div>
      <h1>Java Fibonacci</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Fibonacci in Java.</p>
    </div>
  );
};

export default Java_Fibonacci;
